// function to detect window size
export function validateWindowSize(breakpointValue) {
  const breakpoint = breakpointValue;
  return $(globalThis).width() >= breakpoint;
}

// function to detect local url
export function isLocalUrl(urlToCheck) {
  const clientPath = SITEBASEURL;
  return urlToCheck !== null && urlToCheck.includes(clientPath);
}

// -------------------------------------------------
// function to remove/add target to <a> tags
export function openNewTab(isLocal) {
  return isLocal ? '' : 'target="_blank"';
}

// -------------------------------------------------
// function  function to update custom search bar
export function customSearchBar(searchPlaceholder) {
  $('.header .searchBox input').val('');
  $('.header .searchBox input').attr('placeholder', searchPlaceholder);
}

// -------------------------------------------------
// custom burger menu
export function createCustomToggle() {
  const currentToggle = $(`.mobile-nav-toggle`);
  const closeToggle = $('.mobile-menu-container .close-mobile-menu');

  updateToggle();
  openMenuKeyboard();

  function updateToggle() {
    currentToggle.attr('tabindex', '0');
    for (let i = 0; i < 3; i++) {
      currentToggle.append("<span class='toggle-line'></span>");
    }
  }

  function openMenuKeyboard() {
    currentToggle.on('keydown', function (event) {
      if ((event.key === 'Enter' || event.key === ' ') && !$('body').hasClass('mobile-menu-open')) {
        $(this).trigger('click');
        closeMenuKeyboard();
      }
    });
  }

  function closeMenuKeyboard() {
    closeToggle.attr('tabindex', '0');
    closeToggle.focus();

    closeToggle.on('keydown', function (event) {
      if ((event.key === 'Enter' || event.key === ' ') && $('body').hasClass('mobile-menu-open')) {
        $(this).trigger('click');
      }
      currentToggle.focus();
    });
  }
}

// -------------------------------------------------
// custom search script
export function cloneHeaderItems() {
  const $searchBox = $('.header .searchBox');
  $searchBox.find('.searchBoxSubmit .inputFieldSubmit:first').attr('tabindex', '-1');
}

// -------------------------------------------------
// custom activity stream form
export function appendCustomForm() {
  const formTarget = $('#custom-form');

  if (formTarget.length) {
    formTarget.append(`
      <iframe src='${FULLCLIENTTHEMEPATH}static/activity-stream-form.html' width="100%" height="566" frameborder="0" scrolling="no" id="myFrame"></iframe>
      `);
  }
}
